<template>
  <div class="wrapper-inside p-0">
    <div class="container">
      <b-card>
        <h1>{{ $t('pages.register.title') }}</h1>
        <b-alert
          v-if="registerError"
          show
          variant="danger"
        >
          {{ registerError }}
        </b-alert>
        <form>
          <b-form-group
            id="fieldset-name"
            label-cols-sm="4"
            label-cols-lg="3"
            :label="$t('inputs.first-name.title')"
            label-for="first_name"
            :invalid-feedback="$t('inputs.first-name.validation')"
            :state="nameState"
          >
            <b-form-input
              id="first_name"
              v-model="data.body.first_name"
              size="sm"
            />
          </b-form-group>
          <b-form-group
            id="fieldset-name"
            label-cols-sm="4"
            label-cols-lg="3"
            :label="$t('inputs.last-name.title')"
            label-for="last_name"
            :invalid-feedback="$t('inputs.last-name.validation')"
            :state="nameState"
          >
            <b-form-input
              id="last_name"
              v-model="data.body.last_name"
              size="sm"
            />
          </b-form-group>
          <b-form-group
            id="fieldset-place"
            label-cols-sm="4"
            label-cols-lg="3"
            :label="$t('inputs.place.title')"
          >
            <div class="row">
              <b-form-select
                id="country"
                v-model="data.body.country"
                :options="countryOptions"
                :state="countryState"
                class="col mx-2"
                size="sm"
              />
              <b-form-select
                id="province"
                v-model="data.body.province"
                :options="provinceOptions"
                :state="provinceState"
                class="col mx-2"
                size="sm"
                :disabled="data.body.province == null && data.body.country != 'España'"
              />
              <!-- TODO: hardcoded country check to Espana ^^^^^^^^^^^^^^^^^^^^^^^^^ -->
              <b-form-input
                id="city"
                v-model="data.body.city"
                :placeholder="$t('inputs.place.city.title')"
                :state="cityState"
                type="text"
                size="sm"
                class="col mx-2"
              />
            </div>
          </b-form-group>
          <b-form-group
            id="fieldset-phone"
            label-cols-sm="4"
            label-cols-lg="3"
            :label="$t('inputs.phone.title')"
            label-for="phone"
            :invalid-feedback="$t('inputs.phone.validation')"
            :state="userPhoneState"
          >
            <b-form-input
              id="phone"
              v-model="data.body.phone"
              size="sm"
            />
          </b-form-group>
          <b-form-group
            id="fieldset-email"
            label-cols-sm="4"
            label-cols-lg="3"
            :label="$t('inputs.email.title')"
            label-for="email"
            :invalid-feedback="$t('inputs.email.validation')"
            :state="emailState"
          >
            <b-form-input
              id="email"
              v-model="data.body.email"
              type="email"
              size="sm"
            />
            <div v-if="emailNotif">
              <b-alert
                variant="warning"
                :show="true"
                class="text-center mt-2 mb-0 py-1"
              >
                {{ $t('pages.register.hotmail-warning') }}
              </b-alert>
            </div>
          </b-form-group>
          <b-form-group
            id="fieldset-password"
            label-cols-sm="4"
            label-cols-lg="3"
            :label="$t('inputs.password.title')"
            label-for="password"
            :invalid-feedback="$t('inputs.password.validation')"
            :state="passwordState"
          >
            <b-form-input
              id="password"
              v-model="data.body.password"
              type="password"
              size="sm"
            />
          </b-form-group>
          <b-form-group
            id="fieldset-password-confirm"
            label-cols-sm="4"
            label-cols-lg="3"
            :label="$t('inputs.password-confirm.title')"
            label-for="password-confirm"
            :invalid-feedback="$t('inputs.password-confirm.validation')"
            :state="passwordConfirmState"
          >
            <b-form-input
              id="password-confirm"
              v-model="data.body.password_confirmation"
              type="password"
              size="sm"
            />
          </b-form-group>
          <b-form-group
            id="fieldsetcheckbox-1"
            label-cols-sm="4"
            label-cols-lg="3"
            :label="$t('pages.register.im-a-company')"
            label-for="checkbox-1"
            :state="passwordConfirmState"
          >
            <b-form-checkbox
              id="checkbox-1"
              v-model="data.body.employerSelect"
              class="text-left"
              name="checkbox-1"
            >
              {{ $t('generic.yes') }}
            </b-form-checkbox>
            <b-form-group
              v-if="data.body.employerSelect"
              class="mt-2 text-left"
            >
              <b-form-radio
                v-model="company.employerType"
                name="employerType"
                value="company"
              >
                {{ $t('pages.register.company-type.company') }}
              </b-form-radio>
              <b-form-radio
                v-model="company.employerType"
                name="employerType"
                value="ett"
              >
                {{ $t('pages.register.company-type.temporar') }}
              </b-form-radio>
              <b-form-radio
                v-model="company.employerType"
                name="employerType"
                value="hr"
              >
                {{ $t('pages.register.company-type.headhunter') }}
              </b-form-radio>
              <b-form-radio
                v-model="company.employerType"
                name="employerType"
                value="consultant"
              >
                {{ $t('pages.register.company-type.hr') }}
              </b-form-radio>
            </b-form-group>
          </b-form-group>
          <div
            v-if="data.body.employerSelect"
            class="text-left"
          >
            <div class="form-row">
              <b-form-group
                id="fieldset-name"
                class="col"
                :label="$t('inputs.company-title.title')"
                label-for="title"
                :invalid-feedback="$t('inputs.company-title.validation')"
                :state="titleState"
              >
                <b-form-input
                  id="title"
                  v-model="company.title"
                  size="sm"
                />
              </b-form-group>
            </div>
            <div class="form-row">
              <b-form-group
                id="fieldset-company-phone"
                class="col-md-6"
                :label="$t('inputs.company-phone.title')"
                label-for="phone"
                :invalid-feedback="$t('inputs.company-phone.validation')"
                :state="phoneState"
              >
                <b-form-input
                  id="phone"
                  v-model="company.phone"
                  size="sm"
                />
              </b-form-group>
              <b-form-group
                id="fieldset-number"
                class="col-md-6"
                :label="$t('inputs.company-cif.title')"
                label-for="number"
                :invalid-feedback="$t('inputs.company-cif.validation')"
                :state="checkNIF(company.number)"
              >
                <b-form-input
                  id="number"
                  v-model="company.number"
                  size="sm"
                />
              </b-form-group>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label for="description">{{ $t('inputs.company-description.title') }}</label>
                <b-form-textarea
                  id="description"
                  v-model="company.description"
                  size="sm"
                  class="form-control"
                  cols="4"
                  rows="6"
                  :placeholder="$t('inputs.company-description.placeholder')"
                />
              </div>
            </div>
          </div>
          <!-- Accept rules -->
          <div>
            <b-form-group
              id="fieldsetcheckbox-2"
              label-cols-sm="4"
              label-cols-lg="3"
              :state="acceptConditionsState"
              :invalid-feedback="$t('pages.register.accept-conditions')"
              class="text-left"
            >
              <b-form-checkbox
                id="checkbox-conditions"
                v-model="acceptConditions"
                class="text-left"
                name="checkbox-conditions"
              >
                {{ $t('pages.register.read-the') }}
                <router-link :to="{ name: 'privacy-policy' }">
                  {{ $t('generic.privacy-policy.title') }}
                </router-link>
              </b-form-checkbox>
            </b-form-group>
            <div
              class="mb-3"
              style="font-size: 0.8rem"
            >
              {{ $t('generic.privacy-policy.content') }}
              <router-link :to="{ name: 'privacy-policy' }">
                {{ $t('generic.privacy-policy.title') }}
              </router-link>
            </div>
          </div>
          <b-button
            variant="success"
            :disabled="!readyToSend"
            @click="register"
          >
            {{ $t('pages.register.button') }}
          </b-button>
        </form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import referrals from "@/snippets/referrals";

import {
  countries,
  provinces,
} from "@/assets/data";

export default {
  props: {
    isAdmin: {
      type: Boolean,
      required: false,
    }
  },
  data() {
    return {
      data: {
        body: {
          first_name: '',
          last_name: '',
          phone: '',
          country: '',
          province: '',
          city: '',
          email: '',
          password: '',
          employerSelect: false,
          password_confirmation: ''
        },
        rememberMe: true,
        autoLogin: false,
        redirect: { name: 'RegisterSuccess', params: { email: null } }
      },
      acceptConditions: false,

      loginStart: true,
      registerError: false,
      emailNotif: false,

      company: {
        title: "",
        phone: "",
        number: "",
        description: "",
        user_id: "",
        employerType: 'company',
      }
    }
  },
  computed: {
    countryOptions: () => countries(),
    provinceOptions: () => provinces(),
    nameState() {
      return this.data.body.first_name.length >= 4 || this.loginStart;
    },
    countryState() {
      return this.data.body.country != '';
    },
    provinceState() {
      return this.data.body.country == "España" ? this.data.body.province != null : this.data.body.province == null;
    },
    cityState() {
      return this.data.body.city != '';
    },
    userPhoneState() {
      let re = /^[+]?[0-9]{6,}/;
      return (
        re.test(String(this.data.body.phone)) || this.loginStart
      );
    },
    emailState() {
      /*eslint-disable */
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      /*eslint-enable */
      return (
        re.test(String(this.data.body.email).toLowerCase())  || this.loginStart
      );
    },
    passwordState() {
      return this.data.body.password.length >= 6 || this.loginStart;
    },
    passwordConfirmState() {
      return this.data.body.password === this.data.body.password_confirmation || this.loginStart;
    },
    titleState() {
      return this.company.title.length >= 4;
    },
    phoneState() {
      return this.company.phone.length >= 4;
    },
    acceptConditionsState() {
      return this.acceptConditions || this.loginStart;
    },
    readyToSend() {
      if(!this.data.body.employerSelect) {
        return (
          this.nameState
          && this.countryState
          && this.provinceState
          && this.cityState
          && this.userPhoneState
          && this.emailState
          && this.passwordState
          && this.acceptConditionsState
        )
      } else {
        return this.nameState && this.emailState && this.passwordState &&
          this.titleState && this.phoneState &&
          (this.company.number != null && this.checkNIF(this.company.number) === true) &&
          this.acceptConditionsState;
      }
    },
    ...mapState({
      Permissions: state => state.permissions.permissions,
    }),
  },
  watch: {
    'data.body.email': function(newVal){
        this.emailNotif = false;
        let emailDomain = newVal.split('@')[1];
        if(emailDomain) {
          emailDomain = emailDomain.split('.')[0];
          if(emailDomain === 'hotmail' || emailDomain === 'outlook') {
            this.emailNotif = true;
          }
        }
     },
     'data.body': {
        handler(val) {
          if (val.country !== "España") {
            this.data.body.province = null;
          }
        },
        deep: true
      }
  },
  mounted() {
    // When we create User from admin dashboard
    if(this.isAdmin) {
      this.data.autoLogin = false;
      this.data.redirect = { name: 'admin-users' };
    }
    //
  },
  methods: {
    register() {
      this.loginStart = false;

      this.data.redirect.params.email = this.data.body.email;

      if (this.readyToSend) {
        if (referrals.get()) {
          this.data.body.referral = referrals.get();
        }
        this.$auth.register({
          data: this.data.body, // Axios
          rememberMe: this.data.rememberMe,
          redirect: this.data.redirect,
          autoLogin: this.data.autoLogin,
          success(response) {
            referrals.remove();
            if(this.data.body.employerSelect) {
              this.company.user_id = response.data.Success.id;
              // TODO: rework this into the register endpoint
              // TODO: additional data means company registration
              this.axios.post('/auth/company', this.company)
                .then()
                .catch(() => {
                  this.$toastNotification('danger', '', this.$t('pages.register.invalid-cif'));
                });
            }
            this.$emit('closeModal');

            this.getPermissions();
          },
          error(error) {
            if(error.response.data.errors.email) {
              this.registerError = error.response.data.errors.email[0];
            } else {
              this.registerError = error.response.data.message;
            }
          }
        })
      }
    },
    async getPermissions() {
      if(this.$auth.check()) {
        await this.$store.dispatch('permissions/getPermissions')
          .catch( () => {
          });
      }
    },
    // Validate CIF/NIF
    checkNIF(nif) {
      nif = nif.toUpperCase().replace(/[\s\-]+/g,''); // eslint-disable-line
      if(/^(\d|[XYZ])\d{7}[A-Z]$/.test(nif)) {
        var num = nif.match(/\d+/);
        num = (nif[0]!='Z'? nif[0]!='Y'? 0: 1: 2)+num; // NIE
        if(nif[8]=='TRWAGMYFPDXBNJZSQVHLCKE'[num%23]) {
          // return /^\d/.test(nif)? 'DNI': 'NIE: '+NIF_Type[nif[0]];
          return true;
        }
      }
      else if(/^[ABCDEFGHJKLMNPQRSUVW]\d{7}[\dA-J]$/.test(nif)) {
        for(var sum=0,i=1;i<8;++i) {
          var num = nif[i]<<i%2; // eslint-disable-line
          var uni = num%10;
          sum += (num-uni)/10+uni;
        }
        var c = (10-sum%10)%10;
        if(nif[8]==c || nif[8]=='JABCDEFGHI'[c]) {
          // var out = /^[KLM]/.test(nif)? 'ESP': 'CIF ('+CIF_Prov[nif.substr(1,2)]+')';
          // return out+': '+NIF_Type[nif[0]];
          return true;
        }
      }
      return false;
    }
  }
}
</script>
